/* @flow */
import { dashboardColors } from 'common/enums/ColorEnum';

export default class DifferentiableColorPicker {
    colors = [
        { code: dashboardColors.darkSkyBlue.code },
        { code: '#ff8282' },
        { code: '#a9d171' },
        { code: '#41d1b9' },
        { code: '#d1d141' },
        { code: '#add141' },
        { code: '#89d141' },
        { code: '#41c5d1' },
        { code: '#41a1d1' },
        { code: '#417dd1' },
        { code: '#c6b3ff' },
        { code: '#e5b3ff' },
        { code: '#71d199' },
        { code: '#71d1c9' },
        { code: '#da6161' },
        { code: '#71c1d1' },
        { code: '#71a9d1' },
        { code: '#7191d1' },
        { code: '#7179d1' },
        { code: '#8171d1' },
        { code: '#9971d1' },
        { code: '#b171d1' },
        { code: '#c971d1' },
        { code: '#d171a9' },
        { code: '#d17191' },
        { code: '#ffa182' },
        { code: '#ffccbb' },
        { code: '#54e3a8' },
        { code: '#ffc182' },
        { code: '#ffe082' },
        { code: '#ffd862' },
        { code: '#85d586' },
        { code: '#82e0ff' },
        { code: '#82c1ff' },
        { code: '#82a1ff' },
        { code: '#8282ff' },
        { code: '#a182ff' },
        { code: '#c182ff' },
        { code: '#e082ff' },
        { code: '#ff82c1' },
        { code: '#ff82a1' }
    ];

    noOfColorsGiven: number;

    constructor() {
        this.noOfColorsGiven = 0;
    }

    pick() {
        return this.colors[this.noOfColorsGiven++ % this.colors.length];
    }

    rgbToString = (color: number) => {
        const roundedColor = Math.round(color);
        let updatedColor = roundedColor;
        if (roundedColor < 0) {
            updatedColor = 0;
        }
        if (roundedColor > 255) {
            updatedColor = 255;
        }
        let colorString = updatedColor.toString(16);
        if (colorString.length < 2) {
            colorString = '0' + colorString;
        }
        return colorString;
    };

    colorRGB = (r: number, g: number, b: number) => {
        return (
            '#' +
            this.rgbToString(r) +
            this.rgbToString(g) +
            this.rgbToString(b)
        );
    };

    lighten = (col: string, light: number) => {
        var r = parseInt(col.substr(1, 2), 16);
        var g = parseInt(col.substr(3, 2), 16);
        var b = parseInt(col.substr(5, 2), 16);

        if (light < 0) {
            r = (1 + light) * r;
            g = (1 + light) * g;
            b = (1 + light) * b;
        } else {
            r = (1 - light) * r + light * 255;
            g = (1 - light) * g + light * 255;
            b = (1 - light) * b + light * 255;
        }

        return this.colorRGB(r, g, b);
    };
}
